/**
 * Types for the Production Insights feature
 */

export interface InsightCategory {
  id: string;
  name: string;
  description: string;
  icon: string;
  color: string;
}

export interface Insight {
  id: string;
  title: string;
  finding: string;
  description: string;
  correlation_strength: 'strong' | 'moderate' | 'weak' | 'critical' | 'baseline';
  correlation_value?: number;
  variables_involved?: string[];
  data: Record<string, any>;
  copilot_prompt: string;
  /** Pre-computed detailed explanation shown immediately when user clicks Explore with AI */
  precomputed_explanation?: string;
}

export interface InsightCategoryData {
  velocity: Insight[];
  risk: Insight[];
  correlation: Insight[];
  comparative: Insight[];
}

export interface InsightsApiResponse {
  success: boolean;
  data: InsightCategoryData | InsightCategory[] | Insight[] | null;
  error?: string;
  timestamp: string;
}

export const CATEGORY_ICONS: Record<string, string> = {
  velocity: 'Speed',
  risk: 'Warning',
  correlation: 'Insights',
  comparative: 'Compare',
};

export const CATEGORY_COLORS: Record<string, string> = {
  velocity: '#48BB78',
  risk: '#F56565',
  correlation: '#9F7AEA',
  comparative: '#4299E1',
};

export const CORRELATION_STRENGTH_COLORS: Record<string, string> = {
  strong: '#48BB78',
  moderate: '#ED8936',
  weak: '#A0AEC0',
  critical: '#F56565',
  baseline: '#4299E1',
};
